import { X } from 'lucide-react';
import { Button } from '../ui/button.tsx';

/**
 * The bar above the table while rows are ticked: how many, Add to job, and Clear. Records are
 * not edited in bulk from this screen (the user's call, 2026-11-02); `POST
 * /candidates:bulkUpdate` stays in the API for integrations.
 */
export function BulkBar({
  count,
  onAddToJob,
  onClear,
}: {
  count: number;
  /** Put the ticked rows on a job's shortlist (TS-1599). */
  onAddToJob: () => void;
  onClear: () => void;
}) {
  return (
    <div
      className="bg-brand/5 border-brand/30 mb-2 flex flex-wrap items-center gap-3 rounded-md border px-3 py-2 text-sm"
      data-testid="bulk-bar"
    >
      <span className="font-medium" data-testid="bulk-count">
        {count} selected
      </span>
      <Button
        size="sm"
        variant="outline"
        className="ml-auto"
        onClick={onAddToJob}
        data-testid="bulk-add-to-job"
      >
        Add to job…
      </Button>
      <Button size="sm" variant="ghost" onClick={onClear} aria-label="Clear selection">
        <X /> Clear
      </Button>
    </div>
  );
}
